import { Variant, Variants } from "framer-motion";

import { AnimatedSliderState } from "./types";

export interface AnimatedSliderVariantCustom {
  itemIndex: number;
  activeIndex: number;
  visibleCards: number;
  animationState: AnimatedSliderState;
}

const initialResolver: Variant = ({
  itemIndex,
  visibleCards,
  animationState,
}: AnimatedSliderVariantCustom) => {
  // Keeps the animation even if there is only one card,
  // using taking one of the following card
  visibleCards = Math.max(visibleCards, 2);
  if (itemIndex >= visibleCards) {
    return { opacity: 0 };
  }

  return {
    maxWidth: "50%",
    opacity: 1,
    scale: 0.8 + 0.2 * (visibleCards - itemIndex - 1),
    x:
      animationState === AnimatedSliderState.FINAL
        ? undefined
        : `${75 * (visibleCards - itemIndex - 1)}%`,
    y: animationState === AnimatedSliderState.FINAL ? undefined : "25%",
    zIndex: visibleCards - itemIndex,
  };
};

const animateResolver: Variant = (custom: AnimatedSliderVariantCustom, ...rest) => {
  const { activeIndex, animationState } = custom;

  if (animationState !== AnimatedSliderState.INITIAL) {
    return {
      maxWidth: "100%",
      scale: 1,
      opacity: 1,
      x: `calc((100% + 32px) * -${activeIndex})`,
      y: 0,
      transition:
        animationState === AnimatedSliderState.TRANSITION
          ? {
              duration: 0.6,
              ease: "easeOut",
            }
          : undefined,
    };
  }

  return initialResolver(custom, ...rest);
};

export const slideVariants: Variants = {
  initial: initialResolver,
  animate: animateResolver,
};

export const mobileSlideVariants: Variants = {
  ...slideVariants,
  initial: animateResolver,
};
